import { Component, ChangeDetectionStrategy } from '@angular/core';
import { fadeInAnimation } from '../../_animations/fade-in.animation';

@Component({
    selector: 'app-norge-start',
    templateUrl: './norge-start.component.html',
    animations: [fadeInAnimation],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NorgeStartComponent {
}
